export default __webpack_public_path__ + "static/media/photo_5282747746622312910_y.82b7d0bd.jpg";